import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

import Probabilities from './Probabilities'
import SmartRateHistory from './SmartRateHistory'
import KeyAttributes from './KeyAttributes'
import Loader from '../common/Loader'
import Error from '../common/Error'
import getValidCashflowPredictions from './helpers/getValidCashflowPredictions'
import getValidDefaultPredictions from './helpers/getValidDefaultPredictions'

const Container = styled.div`
  padding: 75px 10px 10px 10px;
  overflow-y: scroll;
  box-sizing: border-box;
  min-height: 20vh;
  max-height: calc(80vh - 65px);
`
const StatusContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40vh;
  text-align: center;
`

const ModalBody = ({ error, loading, loan }) => {
  if (error) {
    return (
      <StatusContainer>
        <Error />
      </StatusContainer>
    )
  } else if (loading || !loan) {
    return (
      <StatusContainer>
        <Loader number={4} />
      </StatusContainer>
    )
  }
  let defaultRiskRating, cashflowRiskRating, topAttrs
  const { product, needsRedecision, predictionResults, smartRate } = loan
  const cashflowPredictions = getValidCashflowPredictions(predictionResults.filter(result => result.predictionModel.type === 'cash_flow' && result.predictionModel.scope === 'global'))
  const [cashflowPrediction] = cashflowPredictions
  const [defaultPrediction] = getValidDefaultPredictions(predictionResults.filter(result => result.predictionModel.type === 'default'))
  const { finalDecision } = product
  const { default_complete_prediction_threshold } = JSON.parse(finalDecision)
  const productUsesDefaultModel = Boolean(default_complete_prediction_threshold)
  if (cashflowPrediction) {
    cashflowRiskRating = cashflowPrediction.riskRating
  }
  if (defaultPrediction) {
    defaultRiskRating = defaultPrediction.riskRating
    topAttrs = defaultPrediction.topAttrs
  }
  return (
    <Container>
      <Probabilities
        smartRate={smartRate}
        cashflowRiskRating={cashflowRiskRating}
        defaultRiskRating={defaultRiskRating}
        needsRedecision={needsRedecision}
        product={product}
        productUsesDefaultModel={productUsesDefaultModel}
      />
      <SmartRateHistory predictionResults={cashflowPredictions} />
      {
        productUsesDefaultModel &&
          <KeyAttributes
            needsRedecision={needsRedecision}
            keyAttributes={topAttrs}
          />
      }
    </Container>
  )
}

ModalBody.propTypes = {
  data: PropTypes.object,
  error: PropTypes.object,
  loading: PropTypes.bool,
  loan: PropTypes.object
}

export default ModalBody
